import mutations from "./../mutations";
import axios from 'axios'
import router from "./../../router";

import uri from './../config'

const { SET_RATES, SET_RATE, SET_DIVISION_RATE, SET_DEPARTMENTS } = mutations;

const rateStore = {
    state: {
        rates: [],
        departments: [],
        rate: {},
    },
    getters: {
        get_rates: ({ rates }) => {
            const sort_rates = rates.sort((a, b) => b.to_rates.length - a.to_rates.length);
            return sort_rates
        },

        get_rates_by_rate_id: ({ rates, rate }) => (_id) => {
            const rate222 = []

            if (rate && rates) {
                rates.forEach(r => {
                    if (r._id != rate._id) {
                        if (rate.to_rates && rate.to_rates.length) {
                            const x = rate.to_rates.filter(rat => rat.from._id == r._id)
                            if (x.length)
                                rate222.push(r)
                        }

                    }
                })
            }
            return rate222

        },

        get_rates_by_rate: ({ rates }) => (type, date) => {

            const new_rates = JSON.parse(JSON.stringify(rates))
            const sort_rates = new_rates.sort((a, b) => {
                let first = a.to_rates.filter(rate => rate.rate == '1')
                let second = b.to_rates.filter(rate => rate.rate == '1')


                //Доделать если одинаковые проента низкого рейтинга
                return ((second.length / b.to_rates.length) * 100).toFixed() - ((first.length / a.to_rates.length) * 100).toFixed()
            });
            return sort_rates
        },

        get_rates_by_rate: ({ rates }) => (type, dates) => {
            
            if (rates) {
                const new_rates = JSON.parse(JSON.stringify(rates))

                const sort_rates = new_rates.sort((a, b) => {
                    if (dates && dates.length) {
                        a.to_rates = a.to_rates.filter(r => r.date >= dates[0] && r.date <= dates[1])
                        b.to_rates = b.to_rates.filter(r => r.date >= dates[0] && r.date <= dates[1])
                    }
                    let first = a.to_rates.filter(rate => rate.rate == '1')
                    let second = b.to_rates.filter(rate => rate.rate == '1')

                    const low_a = a.to_rates.filter((rate) => rate.rate == '1')
                    const middle_a = a.to_rates.filter((rate) => rate.rate == '2')
                    const high_a = a.to_rates.filter((rate) => rate.rate == '3')

                    const low_b = b.to_rates.filter((rate) => rate.rate == '1')
                    const middle_b = b.to_rates.filter((rate) => rate.rate == '2')
                    const high_b = b.to_rates.filter((rate) => rate.rate == '3')

                    const rates_array_a = {}
                    const rates_array_b = {}

                    rates_array_a.low = low_a.length ? ((low_a.length / a.to_rates.length) * 100).toFixed() : 0
                    rates_array_a.middle = middle_a.length ? ((middle_a.length / a.to_rates.length) * 100).toFixed() : 0
                    rates_array_a.high = high_a.length ? ((high_a.length / a.to_rates.length) * 100).toFixed() : 0

                    rates_array_b.low = low_b.length ? ((low_b.length / b.to_rates.length) * 100).toFixed() : 0
                    rates_array_b.middle = middle_b.length ? ((middle_b.length / b.to_rates.length) * 100).toFixed() : 0
                    rates_array_b.high = high_b.length ? ((high_b.length / b.to_rates.length) * 100).toFixed() : 0


                    const max_a = Object.keys(rates_array_a).reduce((a, b) => (rates_array_a[a] * 1 > rates_array_a[b] * 1 ? a : b))

                    const max_b = Object.keys(rates_array_b).reduce((a, b) => (rates_array_b[a] * 1 > rates_array_b[b] * 1 ? a : b))



                    let a_end = 0
                    let b_end = 0

                    switch (max_a) {
                        case 'low':
                            a_end = 1
                            break;
                        case 'middle':
                            a_end = 2
                            break;
                        case 'high':
                            a_end = 3
                            break;

                        default:
                            break;
                    }

                    switch (max_b) {
                        case 'low':
                            b_end = 1
                            break;
                        case 'middle':
                            b_end = 2
                            break;
                        case 'high':
                            b_end = 3
                            break;

                        default:
                            break;
                    }
                    return a_end - b_end

                });

                return sort_rates
            }
        },
        get_rate: ({ rate }) => (type, dates, department_id, rate_value) => {
            const x = JSON.parse(JSON.stringify(rate))
            if (rate.to_rates) {

                switch (type) {
                    case 'new':
                        x.to_rates.reverse()
                        break;

                    default:
                        break;
                }

                //сортировка по рейтингу
                if (rate_value)
                    x.to_rates = x.to_rates.filter(r => r.rate == rate_value)


                //сортировка по выбранному отделу
                if (department_id)
                    x.to_rates = x.to_rates.filter(r => r.from._id == department_id)


                if (dates && dates.length)
                    x.to_rates = x.to_rates.filter(r => r.date >= dates[0] && r.date <= dates[1])

            }
            console.log(x, 'xxx');
            return x

        },

        get_departments: ({ departments }) => departments.filter(d => d.from_rates.length),
        get_departments_by_rate: ({ departments }) => {
            
            const filter_without_dep = departments.filter(d => !d.from_rates.length)
            const filter_with_dep = departments.filter(d => d.from_rates.length)
            const sort_rates = filter_with_dep.sort((a, b) => {
                let first = a.from_rates.filter(rate => rate.rate == '1')
                let second = b.from_rates.filter(rate => rate.rate == '1')


                if (!first.length && !second.length) {
                    first = a.from_rates.filter(rate => rate.rate == '2')
                    second = b.from_rates.filter(rate => rate.rate == '2')
                }

                if (!first.length && !second.length) {
                    first = a.from_rates.filter(rate => rate.rate == '3')
                    second = b.from_rates.filter(rate => rate.rate == '3')
                }
                //Доделать если одинаковые проента низкого рейтинга
                return ((second.length / b.from_rates.length) * 100).toFixed() - ((first.length / a.from_rates.length) * 100).toFixed()
            });

            filter_without_dep.forEach(dep => {
                sort_rates.push(dep)
            })
            return sort_rates
        },
        get_count_departments: ({ departments }) => {
            const filter_dep = departments.filter(d => d.from_rates.length)
            return filter_dep.length
        }

    },
    mutations: {
        [SET_RATES](state, payload) {
            state.rates = payload;
        },

        [SET_DEPARTMENTS](state, payload) {
            state.departments = payload;
        },

        [SET_DIVISION_RATE](state, payload) {
            state.rate = payload;
        },

        [SET_RATE](state, payload) {
            const user = state.rates.find(user => user._id == payload.to)
            user.to_rates.unshift(payload);

        },

    },
    actions: {

        async load_rates({ commit }) {
            const instance = await axios.create({
                baseURL: uri,
                headers: {
                    "Content-Type": "application/json",
                    "X-token": localStorage.getItem("_token"),
                    "title": localStorage.getItem("title"),
                    "_id": localStorage.getItem("_id"),
                },
            });

            instance
                .get('/rates')
                .then(r => r.data)
                .then(data => {
                    
                    commit(SET_RATES, data.rates)
                }).catch(err => {
                    if (err.response.status == 401)
                        router.push("/statistic")

                    if (err.response.status == 403)
                        router.push("/statistic")
                })
        },

        async load_rate({ commit }, _id) {
            const instance = await axios.create({
                baseURL: uri,
                headers: {
                    "Content-Type": "application/json",
                    "X-token": localStorage.getItem("_token"),
                    "title": localStorage.getItem("title"),
                    "_id": localStorage.getItem("_id"),
                },
            });

            instance
                .get(`/rates/${_id}`)
                .then(r => r.data)
                .then(data => {
                    commit(SET_DIVISION_RATE, data.rate)
                }).catch(err => {
                    if (err.response.status == 401)
                        router.push("/statistic")
                })
        },

        async create_rate({ commit }, data) {

            const instance = await axios.create({
                baseURL: uri,
                headers: {
                    "Content-Type": "application/json",
                    "X-token": localStorage.getItem("_token"),
                    "title": localStorage.getItem("title"),
                    "_id": localStorage.getItem("_id"),
                },
            });

            instance

                .post(`/rates`, data)
                .then(r => r.data)
                .then(data => {

                    commit(SET_RATE, data.rate)
                })
        },

        async load_departments({ commit }, _id) {
            const instance = await axios.create({
                baseURL: uri,
                headers: {
                    "Content-Type": "application/json",
                    "X-token": localStorage.getItem("_token"),
                    "title": localStorage.getItem("title"),
                    "_id": localStorage.getItem("_id"),
                },
            });

            instance
                .get(`/rates/all_departments/${_id}`)
                .then(r => r.data)
                .then(data => {
                    commit(SET_DEPARTMENTS, data.departments)
                    commit(SET_DIVISION_RATE, data.user)
                }).catch(err => {
                    if (err.response.status == 401)
                        router.push("/statistic")
                })
        },




    }
};

export default rateStore;